import { Component } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { httpRoutes, httpVersion } from 'src/consts/http-routes';
import { localStorageConstants } from 'src/consts/local-storage-constants';
import { HttpCall } from '../services/httpcall.service';
import { UiSpinnerService } from '../services/ui-spinner.service';
import { WEB_ROUTES } from 'src/consts/routes';
import { CommonService } from '../services/common.service';
import { UnsubscribeOnDestroyAdapter } from '../shared/UnsubscribeOnDestroyAdapter';
import { AuthenticationService } from '../authentication/authentication.service';
import { SeoService } from '../seo.service';

@Component({
    selector: 'app-landing-page',
    templateUrl: './landing-page.component.html',
    styleUrls: ['./landing-page.component.scss'],
    standalone: false
})
export class LandingPageComponent extends UnsubscribeOnDestroyAdapter {
  // userdata: any = null;
  useremail: any;
  qureyemail: any;
  public routers: typeof WEB_ROUTES = WEB_ROUTES;
  constructor(private seo: SeoService, public uiSpinner: UiSpinnerService, private router: Router, private commonService: CommonService, private authenticationService: AuthenticationService,
    public route: ActivatedRoute, public httpCall: HttpCall) {
    super();
    this.seo.setTags({
      title: 'SmartAccuPay landing page', // Title
      titleSuffix: '- SmartAccuPay', // Title Suffix
      description: 'SmartAccuPay Invoice Management', // Description
      image: '', // Image
      keywords: 'SmartAccuPay' // Keywords
    });
  }

  async ngOnInit(): Promise<void> { // Mark the function as async

    const token = await localStorage.getItem(localStorageConstants.INVOICE_TOKEN);
    const user_type = await localStorage.getItem(localStorageConstants.USERTYPE);
    const userdata = await localStorage.getItem(localStorageConstants.USERDATA);
    const useremail = userdata ? JSON.parse(userdata) : null;

    if (token && userdata) {

      this.qureyemail = this.route.snapshot.queryParamMap.get('email') as String;
      this.useremail = useremail.UserData.useremail;
      if (this.qureyemail.trim() === this.useremail.trim()) {
        this.router.navigate([this.routers.DASHBOARD]).then();
      } else {
        this.authenticationService.changeLoginValue(true);
        this.authenticationService.changeTokenValue('');
        localStorage.removeItem(localStorageConstants.DARKMODE);
        localStorage.removeItem(localStorageConstants.USERDATA);
        localStorage.removeItem(localStorageConstants.COMPANYDATA);
        localStorage.removeItem(localStorageConstants.COMPANYID);
        localStorage.removeItem(localStorageConstants.INVOICE_GIF);
        localStorage.removeItem(localStorageConstants.INVOICE_TOKEN);
        localStorage.setItem(localStorageConstants.LOGOUT, 'true');
        localStorage.removeItem('choose_logoheader');
        localStorage.removeItem('choose_skin');
        localStorage.removeItem('menuOption');
        localStorage.removeItem('thinvoicetheme');
        this.router.navigate([this.routers.LOGIN]).then();
      }
    } else {

      let email = this.route.snapshot.queryParamMap.get('email');
      let companycode: any = this.route.snapshot.queryParamMap.get('compnaycode');
      let that = this;
      that.uiSpinner.spin$.next(true);
      const data = await this.commonService.postRequestAPI(httpVersion.PORTAL_V1 + httpRoutes.LOGIN_FROM_OTHER_APP, {
        useremail: email,
        companycode: companycode
      });
      // this.httpCall.httpPostCall(httpRoutes.LOGIN_FROM_OTHER_APP, reqObject).subscribe((data) => {
      await localStorage.setItem('token', data.data.token);
      await localStorage.setItem(localStorageConstants.USERDATA, JSON.stringify(data.data));
      await localStorage.setItem(localStorageConstants.USERTYPE, 'portal');
      await localStorage.setItem(localStorageConstants.COMPANYCODE, companycode);
      that.uiSpinner.spin$.next(false);
      if (data.data.UserData.useris_password_temp == false) {
        if (email == useremail.UserData.useremail) {
          that.router.navigate([that.routers.DASHBOARD]).then();
        } else {
          that.router.navigate([that.routers.LOGIN]).then();
        }
      }
      else {
        that.router.navigateByUrl('/forcefully-changepassword');
      }
      //http://localhost:4200/landing-page?email=kttailor4u@gmail.com &compnaycode=R-988514
    }
  }
}